import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AcademycoachesService } from 'src/app/services/academycoaches.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { environment } from 'src/environments/environment';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
@Component({
  selector: 'app-coaches',
  templateUrl: './coaches.component.html',
  styleUrls: ['./coaches.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class CoachesComponent implements OnInit {
  public showingForm: boolean = false;
  coachform: FormGroup
  submitted = false;
  imageSize = environment.imageSize;
  uploadedFiles: any[] = [];
  academyImage: any = [];
  coachImage: any;
  id: string;
  pagetitle: string;
  isAddMode: boolean = true;
  coachData: any;
  loading: boolean;
  errorMessage = '';
  loggedInAcademy;
  loggedInAcademyId;
  item: any;
  coachid: any;
  imagecoach: any;
  public disabled: boolean = false;
  showUploadedpic: boolean = false;
  public court_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
    },
    // navigation: false,
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    }
  };
  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private messageService: MessageService, private router: Router, private tokenStorage: TokenStorageService, private coachservice: AcademycoachesService, private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.loggedInAcademy = this.tokenStorage.getUser();
    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    let academyPaymentDetails = this.loggedInAcademy.userdata.academyPaymentDetails;
    let roleName = this.loggedInAcademy.userdata.rolename;
    let currentUrl = '/';
    if (roleName == "academy") {
      if (Object.keys(academyPaymentDetails).length > 0) {
        if (academyPaymentDetails.academyPaymentStatus == 'created') {
          currentUrl = '/payment-history';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      } else {
        currentUrl = '/payment-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
    }
    this.coachform = this.formBuilder.group({
      coachName: ['', [Validators.required, Validators.pattern("([a-zA-Z',.-_]+( [a-zA-Z',.-_]+)*){2,30}")]],
      coachRole: ['', [Validators.required]],
    }, { updateOn: "blur" });
    this.loadcoach();
  }
  get f() {
    return this.coachform.controls;
  }
  openmodal() {
    this.imagecoach = '';
    this.uploadedFiles = [];
    this.pagetitle = 'Add Coach';
    this.isAddMode = true;
    this.showingForm = true;
    this.coachform.reset();
  }
  onHighlightModalClose() {
    this.showingForm = false;
  }
  onClickEdit(id) {
    this.imagecoach = '';
    this.uploadedFiles = [];
    this.pagetitle = 'Edit Coach';
    this.isAddMode = false;
    this.showingForm = true;
    this.getcoachdetails(id);
  }
  getcoachdetails(id) {
    this.coachservice.getAcademyCoachdetails(id).subscribe(res => {
      this.item = res;
      this.coachid = id;
      this.coachform.controls.coachName.setValue(this.item.coachName);
      this.coachform.controls.coachRole.setValue(this.item.coachRole);
      if (this.item['image'] != undefined) {
        this.imagecoach = this.item['image'];
        this.showUploadedpic = true;
      } else {
        this.showUploadedpic = false;
      }
    })
  }
  picUploader(event) {
    this.uploadedFiles = [];
    // console.log("uploadimage",event.file);   
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.coachImage = reader.result;
        }
      }
    }
  }
  loadcoach() {
    var query = "?filterByDisable=false&filterByAcademyId=" + this.loggedInAcademyId;
    this.coachservice.getAcademyCoaches(query).subscribe(data => {
      this.loading = false;
      this.coachData = data.data.items;
    },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  onsubmit() {
    this.submitted = true;
    if (this.coachform.invalid) {
      return;
    }
    console.log(this.coachform.value);

    var coachData = this.coachform.value;
    coachData['status'] = true;
    coachData['disable'] = false;
    coachData['coachImage'] = this.coachImage;
    coachData['academyId'] = this.loggedInAcademyId;
    if (this.isAddMode) {
      coachData = JSON.stringify(coachData, null, 4);
      this.addCoach(coachData);
    } else {
      this.isAddMode = false
      coachData = JSON.stringify(coachData, null, 4);
      this.updateCoach(coachData);
    }
  }
  addCoach(coachData) {
    this.coachservice.addAcademyCoaches(coachData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Coach Added Successfully', life: 6000 });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate(['/academies-profile/coaches']);
        }, 200);
        this.uploadedFiles = [];
        this.imagecoach = '';
        this.coachform.reset();
        this.onHighlightModalClose();
        //this.loadcoach();

      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add Coach failed', life: 6000 });
        this.coachform.reset();
        this.onHighlightModalClose();

      })
    );
  }
  updateCoach(coachData) {
    this.coachservice.updateAcademyCoaches(this.coachid, coachData).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Coach Updated Successfully', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/academies-profile/coaches']);
        }, 2000);
        this.uploadedFiles = [];
        this.imagecoach = '';
        this.coachform.reset();
        this.onHighlightModalClose();
        this.loadcoach();
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update Coach failed', life: 6000 });
        this.coachform.reset();
        this.onHighlightModalClose();
      })

    );
  }
  onClickDelete(data) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this coach?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        let disableStatus;
        if (data.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        let updatedata = '{"disable":' + disableStatus + '}';
        this.coachservice.updateAcademyCoaches(data.id, updatedata).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Coach Deleted', life: 3000 });
            this.loadcoach();
          },
          err => {
            this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: 'System Error. Please try again.', life: 3000 });
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }

  public onIndexChange(index: number): void {
    //console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    //console.log('Swiper event: ', event);
  }

  public toggleKeyboardControl(): void {
    this.court_config.keyboard = !this.court_config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.court_config.mousewheel = !this.court_config.mousewheel;
  }

}
